<template>
  <div>
    <topbar></topbar>
    <search-bar></search-bar>
    <div class="main">
      <div class="user_order_title">
        <span class="title">用户中心</span>
      </div>
    </div>

    <div class="user_address">
      <div class="main">
        <div class="user_order_main_left">
          <ul>
            <li :class="selectRouter('/userInfoCenter')">
              <a @click="goRouter('/userInfoCenter')" href="javascript:void(0)">
                <i class="el-icon-shopping-bag-1"></i>
                <span>门店信息</span>
              </a>
            </li>
            <li :class="selectRouter('/userInfoPayment')">
              <a @click="goRouter('/userInfoPayment')" href="javascript:void(0)">
                <i class="el-icon-location"></i>
                <span>收支明细</span>
              </a>
            </li>
            <li :class="selectRouter('/userAddress')">
              <a @click="goRouter('/userAddress')" href="javascript:void(0)">
                <i class="el-icon-location"></i>
                <span>收货地址</span>
              </a>
            </li>
            <!--            <li>-->
            <!--              <a href="">-->
            <!--                <i class="el-icon-data-line"></i>-->
            <!--                <span>数据统计</span>-->
            <!--              </a>-->
            <!--            </li>-->
            <li :class="selectRouter('/changePassword')">
              <a @click="goRouter('/changePassword')" href="javascript:void(0)">
                <i class="el-icon-unlock"></i>
                <span>修改密码</span>
              </a>
            </li>
          </ul>
        </div>
        <div>
          <router-view/>
        </div>
      </div>
    </div>
    <footer-bar></footer-bar>
  </div>
</template>

<script>
import Topbar from '../top/topbar'
import SearchBar from '../search/searchBar'
import footerBar from '../footer/footerBar'

export default {
  name: 'index',
  components: {footerBar, SearchBar, Topbar}
  , data () {

    return {}
  },
  methods: {
    goRouter (url) {
      if (this.$route.path && this.$route.path != url) {
        this.$router.push(url)
      }
    },
    selectRouter (url) {
      if (url === this.$route.path) {
        return 'user_order_select'
      }
    }
  }, created () {

  }
}
</script>

<style scoped>
@import "../../assets/style/index.css";

.user_address {
  margin-top: 18px;
  overflow: hidden;
  margin-bottom: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/userCenter/userBar.vue